export default "__VITE_ASSET__Cl4$Q0FQ__"